import { AgencyConfigData } from '@app/models';

export class ApplicationConfig {
  appName: string;
  build: string;
}

export var getAppConfiguration = function () {
  let cnf = new ApplicationConfig()
  cnf.build = "2.20.01"
  return cnf;
}

export var apiconfig = {

  CHECK_VERSION: "https://portal.agence-impact.com/version.json",

  ANIMA_URL: "https://anima.agence-impact.com",
  ANIMA_REPORTS_URL: "https://anima.agence-impact.com/reports",

  // Dynamically set on Login according to the host name
  API_URL: "/dummy",

  DEV_API_URL: "http://localhost:8092/api",
  PROD_API_URL: "https://lo-api.loga.one/api",
  STAGING_API_URL: "https://staging-lo-api.loga.one/api",

  // -- Commons and Components
  LOGA_ICONS: "https://loga-icons.impgrp.info/icons",
  API_KPI: "https://loga2-reports.agence-impact.com"
  //////////////// DEV
  //API_KPI: "http://localhost:8095"
}

/**
 * Agency Config is used to display the default agency logo, and the name of agencies
 */
export class AgencyConfigFiles {
  defaultConfig: string = 'ifmg';
  hosts: {[key: string]: string} = {
    'localhost': 'ifmg',
    'staging-locupa.loga.one': 'ifmg-staging',
    'portal.atmospheres.tm.fr': 'atmospheres',
    'portal.agence-athena.fr': 'athena',
    'portal.agence-impact.com': 'impact'
  };

  config: {[key: string]: AgencyConfigData} = {
    'ifmg': {
      appName: "marving",
      appNameShort: "",
      name: "Marvesting Customer Portal",
      phone: "accueil@marvesting.com",
      url: "https://marvesting.com/",
      addressL1: "",
      addressL2: "",
      addressCountry: "France",
      logo: 'https://loga-icons.impgrp.info/icons/agency/0/square',
      logoLarge: 'https://loga-icons.impgrp.info/icons/agency/0/square',
      locupa2: 'http://localhost:8101',
      platformType: 'dev'
    },

    'ifmg-staging': {
      appName: "marving",
      appNameShort: "",
      name: "Marvesting Customer Portal Staging",
      phone: "accueil@marvesting.com",
      url: "https://marvesting.com/",
      addressL1: "",
      addressL2: "",
      addressCountry: "France",
      logo: 'https://loga-icons.impgrp.info/icons/agency/0/square',
      logoLarge: 'https://loga-icons.impgrp.info/icons/agency/0/square',
      locupa2: 'https://staging-locupa2.loga.one',
      platformType: 'staging'
    },

    'atmospheres': {
      appName: "marving",
      appNameShort: "",
      name: "Atmospheres",
      phone: "01.61.37.39.39",
      url: "https://www.atmospheres.tm.fr/",
      addressL1: "20 rue Georges Méliès",
      addressL2: "78390 Bois d'Arcy",
      addressCountry: "France",
      logo: 'https://loga-icons.impgrp.info/icons/agency/3/square',
      logoLarge: 'https://loga-icons.impgrp.info/icons/agency/3/square',
      locupa2: 'https://portal2.atmospheres.tm.fr',
      platformType: 'prod'
    },

    'impact': {
      appName: "marving",
      appNameShort: "",
      name: "Impact Sales and Marketing",
      phone: "01.41.27.91.00",
      url: "https://www.agence-impact.com",
      addressL1: "116 Rue Victor Hugo 102",
      addressL2: "92300 Levallois-Perret",
      addressCountry: "France",
      logo: 'https://loga-icons.impgrp.info/icons/agency/1/square',
      logoLarge: 'https://loga-icons.impgrp.info/icons/agency/1/square',
      locupa2: 'https://portal2.agence-impact.com',
      platformType: 'prod'
    },

    'athena': {
      appName: "marving",
      appNameShort: "",
      name: "Athena",
      phone: "01.30.12.47.23",
      url: "https://agence-athena.fr",
      addressL1: "20 rue Georges Méliès",
      addressL2: "78390 Bois d'Arcy",
      addressCountry: "France",
      logo: 'https://loga-icons.impgrp.info/icons/agency/5/square',
      logoLarge: 'https://loga-icons.impgrp.info/icons/agency/5/square',
      locupa2: 'https://portal2.agence-athena.fr',
      platformType: 'prod'
    }
  }
}
